import { Euler, Matrix4, Quaternion, Vector3 } from 'three'
import type { OBB } from 'three/examples/jsm/math/OBB'

/**
 * Instrumentación de depuración del arrastre/colisión de pouffs.
 *
 * NO cambia ningún comportamiento: solo emite logs cuando se activa por consola.
 * Activar:   window.__POUFF_DEBUG__ = true
 * Desactivar: window.__POUFF_DEBUG__ = false
 *
 * Cada grupo de logs comparte un nº de frame para poder reconstruir, tick a tick,
 * qué propuso el puntero, qué decidió la colisión y qué quedó persistido en Zustand.
 */

let frame = 0

export const pouffDebugNextFrame = (): number => ++frame
export const pouffDebugFrame = (): number => frame

export const isPouffDebugEnabled = (): boolean =>
  typeof window !== 'undefined' &&
  (window as Window & { __POUFF_DEBUG__?: boolean }).__POUFF_DEBUG__ === true

const r = (n: number): number => Math.round(n * 100) / 100

/** Decompone una matriz a pos/rot/escala + elementos crudos, para comparar lógico vs visual. */
export function describeMatrix(m?: Matrix4 | null): Record<string, unknown> | null {
  if (!m) return null
  const p = new Vector3()
  const q = new Quaternion()
  const s = new Vector3()
  m.decompose(p, q, s)
  const e = new Euler().setFromQuaternion(q)
  return {
    pos: { x: r(p.x), y: r(p.y), z: r(p.z) },
    rotYdeg: r((e.y * 180) / Math.PI),
    quat: { x: r(q.x), y: r(q.y), z: r(q.z), w: r(q.w) },
    scale: { x: r(s.x), y: r(s.y), z: r(s.z) },
    elements: Array.from(m.elements).map(r),
  }
}

export function describeOBB(box?: OBB | null): Record<string, unknown> | null {
  if (!box) return null
  return {
    center: { x: r(box.center.x), y: r(box.center.y), z: r(box.center.z) },
    halfSize: { x: r(box.halfSize.x), y: r(box.halfSize.y), z: r(box.halfSize.z) },
    rotation: Array.from(box.rotation.elements).map(r),
  }
}

export function pouffLog(stage: string, data: Record<string, unknown>): void {
  if (!isPouffDebugEnabled()) return
  // eslint-disable-next-line no-console
  // console.log(`[POUFF ${stage}] f#${frame} t=${performance.now().toFixed(1)}ms`, data)
}
